export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13823.0535e832.jpg";